<ng-container>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 float-end">
        <button
          (click)="submit()"
          class="btn btn-primary btn-cta"
          aria-label="next"
        >
          {{ cmsSearchWidgetCopy.next }}
        </button>
      </div>
    </div>
  </div>
</ng-container>


